"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortationPackageType = exports.SortationPackageError = exports.SortationPackageStatus = exports.SortationPackageProviderName = void 0;
var SortationPackageProviderName;
(function (SortationPackageProviderName) {
    SortationPackageProviderName["GLOBALE"] = "GLOBALE";
})(SortationPackageProviderName = exports.SortationPackageProviderName || (exports.SortationPackageProviderName = {}));
var SortationPackageStatus;
(function (SortationPackageStatus) {
    SortationPackageStatus["ARRIVED"] = "ARRIVED";
    SortationPackageStatus["ASSIGNED_TO_GAYLORD"] = "ASSIGNED_TO_GAYLORD";
    SortationPackageStatus["CREATED"] = "CREATED";
})(SortationPackageStatus = exports.SortationPackageStatus || (exports.SortationPackageStatus = {}));
var SortationPackageError;
(function (SortationPackageError) {
    SortationPackageError["CANCELLATION_FAILED_SCANNED_PACKAGE"] = "CANCELLATION_FAILED_SCANNED_PACKAGE";
    SortationPackageError["DUPLICATE_TRACKING_CODES"] = "DUPLICATE_TRACKING_CODES";
    SortationPackageError["INVALID_SHIPPING_LABEL_INFO"] = "INVALID_SHIPPING_LABEL_INFO";
    SortationPackageError["SORT_CODE_MISSORT"] = "SORT_CODE_MISSORT";
    SortationPackageError["SORTATION_PACKAGE_EXISTS"] = "SORTATION_PACKAGE_EXISTS";
    SortationPackageError["SORTATION_PACKAGE_NOT_FOUND"] = "SORTATION_PACKAGE_NOT_FOUND";
    SortationPackageError["TRACKING_CODE_NOT_FOUND"] = "TRACKING_CODE_NOT_FOUND";
    SortationPackageError["SORTATION_PACKAGE_CANCELED"] = "SORTATION_PACKAGE_CANCELED";
    SortationPackageError["TRACKING_CODE_EXPIRED"] = "TRACKING_CODE_EXPIRED";
})(SortationPackageError = exports.SortationPackageError || (exports.SortationPackageError = {}));
var SortationPackageType;
(function (SortationPackageType) {
    SortationPackageType["FULFILLMENT"] = "FULFILLMENT";
    SortationPackageType["UNBUNDLED_PARCEL"] = "UNBUNDLED_PARCEL";
})(SortationPackageType = exports.SortationPackageType || (exports.SortationPackageType = {}));
//# sourceMappingURL=SortationPackage.js.map